import React from 'react'
import { OptionStyled } from '@mobi/component-library/Common/Select'
import type { CountryList } from '@mobi/api-types'

export const PopularCountryList = ({ countries }: { countries: CountryList }) => {
  const popularCountries = ['Australia', 'New Zealand', 'United Kingdom'] // Top three countries, selected based on country of origin of customers
  const popularOptions = countries.filter(c => popularCountries.find(p => p === c.description))

  return (
    <optgroup label='Popular selections'>
      {popularOptions.map(opt => (
        <OptionStyled key={opt.code} value={opt.code}>
          {opt.description}
        </OptionStyled>
      ))}
    </optgroup>
  )
}

export const AlphabeticalCountryList = ({ countries }: { countries: CountryList }) => (
  <optgroup label='Alphabetical'>
    {countries.map(opt => (
      <OptionStyled key={opt.code} value={opt.code}>
        {opt.description}
      </OptionStyled>
    ))}
  </optgroup>
)
